import { Typography } from "@mui/material";
import { theme } from "../../../Common/UI/styles/theme";

export default function ReleaseTwoPointFour() {
  return (
    <>
      <Typography variant="h6" className="release-title" color={theme.palette.error.main}>
        RELEASE 2.6 – June 16th , 2025
      </Typography>
      <ul>
        <li>
          Reports – CrunchTime Weekly Sales Diff 
          <ul>
            <li style={{ listStyleType: "circle" }}>
              Enhanced the Weekly Sales diff report by adding ability to color code variances and add comments.
            </li>
            <li style={{ listStyleType: "circle" }}>
              Show Details button will show check number variances between POS & CT for easier troubleshooting
            </li>
          </ul>
        </li>
      </ul>
    </>
  );
}
